// dependency-graph-ignore-file
import { valueToCollabJSON } from '@databases/collab/convert/to-collab';
import { setValueValue } from '@databases/collab/y-database';
import { type YEntry } from '@databases/collab/y-entry';
import { type Database } from '@databases/model/database';
import { type FieldType } from '@databases/model/field';
import { type DatabaseFieldType, type DatabaseValue } from '@databases/types/database';

import { type StrictDatabaseValue } from '../../domain/entries/validators.ts';

interface SetValueParams {
  entry: YEntry;
  fieldId: string;
  fieldType: FieldType;
  value: StrictDatabaseValue;
  resetValue?: boolean;
}

export function setValue(
  ydb: Database,
  { entry, fieldId, fieldType, value, resetValue }: SetValueParams
): void {
  ydb.mutate(() => {
    if (resetValue) {
      entry.removeValue(fieldId);
    }
    const mutableValue = entry.setValue(fieldId, fieldType);

    const valueJson = valueToCollabJSON(value as DatabaseValue<DatabaseFieldType>, {});

    if (valueJson) {
      setValueValue(mutableValue, valueJson);
    }
  });
}
